import React from 'react'
import './animation.scss';
import logo from '../../images/logo.png'
function Page_animation() {
  return (
    <div className='page_animation'>
        <img src={logo} alt='Logo' className='logo'/>
    </div>
  )
}

export default Page_animation